export default __webpack_public_path__ + "static/media/dashlane.6cb853a4.svg";